// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC9w6O0U9VqxSfnmJGZX5wWwCbQ0bUwT8k",
  authDomain: "navyabakers-1d955.firebaseapp.com",
  projectId: "navyabakers-1d955",
  storageBucket: "navyabakers-1d955.firebasestorage.app",
  messagingSenderId: "175075204983",
  appId: "1:175075204983:web:dd4c6db11c85647167cb72",
  measurementId: "G-BT1E1VETX2",
};

// Initialize Firebase using modular approach
const app = initializeApp(firebaseConfig);

// Initialize Firebase Messaging
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
